import { render, staticRenderFns } from "./statuses.vue?vue&type=template&id=0ff442d2&scoped=true&"
import script from "./statuses.vue?vue&type=script&lang=js&"
export * from "./statuses.vue?vue&type=script&lang=js&"
import style0 from "../less/profileSettings.less?vue&type=style&index=0&id=0ff442d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff442d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ff442d2')) {
      api.createRecord('0ff442d2', component.options)
    } else {
      api.reload('0ff442d2', component.options)
    }
    module.hot.accept("./statuses.vue?vue&type=template&id=0ff442d2&scoped=true&", function () {
      api.rerender('0ff442d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/profileSettings/pages/statuses.vue"
export default component.exports